<script lang="ts">
  import { Modal, ModalBody } from "sveltestrap";
  import { BusinessSerialiser } from "/apiFactory";
  import { getSpotlightCoverImageLink } from "/traveller/utils.js";
  import Form from "./Form.svelte";

  export let isOpen: boolean = false;
  export let business: BusinessSerialiser;
  export let toggle: () => void;

  const defaultCoverImage = business.cover_image_uuid
    ? ""
    : // @ts-ignore
      getSpotlightCoverImageLink(business.country.code);
  // make open/close snappier
  const transitionOptions = { duration: 150 };
</script>

<style lang="scss">
  .top-right {
    /* Custom class as we don't place the button in the header */
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem 1rem;
    z-index: 1004;
  }
  :global(.modal-content) {
    border: 0;
  }
</style>

<Modal {isOpen} {toggle} {transitionOptions}>
  <ModalBody class="p-0 mb-4">
    <button type="button" on:click={toggle} class="close top-right" aria-label="Close">
      <span aria-hidden="true">
        <i class="far far-times text-white" />
      </span>
    </button>
    <slot name="header">
      <div class="embed-responsive embed-responsive-21by9">
        <div
          class="d-flex align-items-end dark-overlay bg-cover rounded-lg-top
          embed-responsive-item"
          data-blink-uuid={business.cover_image_uuid}
          data-blink-src={defaultCoverImage}>
          <div class="container overlay-content py-2">
            <div class="row">
              <div class="col-12">
                <div class="text-white text-center h1 font-weight-bold">
                  {business.name}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </slot>
    <div class="container pt-3 px-5">
      <div class="h3 font-weight-bold text-center">Book Direct</div>
      <div class="font-weight-light text-muted text-center">
        {business.name} usually reply within a few hours
      </div>
      <hr class="mb-4" />
      <Form {business} on:success={toggle} on:cancel={toggle} />
    </div>
  </ModalBody>
</Modal>

<slot name="extra-modal" />
